

/*
 Brand Wishlist Button
*/

const BRAND_WISHLIST_OPTIMISTIC_DISABLE_MS = 500;

function brandDisableTemporarily(element, duration = BRAND_WISHLIST_OPTIMISTIC_DISABLE_MS) {
  if (!element) return;
  element.disabled = true;
  if (element._brandWishlistDisableTimer) {
    clearTimeout(element._brandWishlistDisableTimer);
  }
  element._brandWishlistDisableTimer = setTimeout(() => {
    element.disabled = false;
    element._brandWishlistDisableTimer = null;
  }, duration);
}

class BrandWishlistButton {
  constructor(button) {
    this.button = button;
    this.button._brandWishlistListInstance = this;
    this.objectType = button.dataset.objectType || 'brand';
    this.objectId = button.dataset.objectId;
    this.customerId = button.dataset.customerId;
    
    // Config fallback: use window.multilikesConfig or default app proxy
    this.defaultUrl = window.multilikesConfig?.defaultUrl;
    
    if (this.customerId) {
      this.init();
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleFavorite();
      });
    } else {
       // ログインしていない場合はログインページへ遷移
       this.button.addEventListener('click', (e) => {
         e.preventDefault();
         window.location.href = '/account/login?return_url=/pages/brandlist';
       });
    }
  }

  async init() {
    await this.fetchLatestData();
    this.updateFavoriteCountElement();
  }

  async fetchLatestData() {
    try {
      const params = new URLSearchParams({
        customer_id: this.customerId,
        type: this.objectType,
        metaobject_id: this.objectId
      });

      const response = await fetch(`${this.defaultUrl}?${params.toString()}`);
      if (!response.ok) return;
      const result = await response.json();
      console.log("fetchLatestData::result",result);

      const item = result.data;
      
      if (item) {
        // カウントを取得
        this.favoriteCount = this.getFavoriteCountFromItem(item);

        console.log("fetchLatestData::favoriteCount",this.favoriteCount);
        // 現在のステータス（Liquidで設定されたクラス）を維持しつつ、カウントを反映
        const isFavorited = this.button.classList.contains('is-active');
        this.updateButton(isFavorited);
      }

    } catch (e) {
      console.error('Error fetching brand wishlist data:', e);
    }
  }

  getFavoriteCountFromItem(item) {
    let count = item.favoriteCount;
    
    // プロパティにない場合はfieldsから探す
    if (typeof count !== 'number' && item.fields && Array.isArray(item.fields)) {
      const field = item.fields.find(f => f.key === 'favorite_count');
      if (field) {
        count = field.value ?? field.jsonValue;
      }
    }
    
    // 数値変換
    if (count === null || count === undefined) return 0;
    const num = Number(count);
    return Number.isNaN(num) ? 0 : Math.max(0, num);
  }

  async toggleFavorite() {
    const isCurrentlyFavorited = this.button.classList.contains('is-active');
    const nextState = !isCurrentlyFavorited;
    const action = nextState ? 'add' : 'remove';
    const previousCount = this.favoriteCount;

    // 楽観更新：先にUIを反映
    if (nextState) {
      this.favoriteCount = (this.favoriteCount || 0) + 1;
    } else {
      this.favoriteCount = Math.max(0, (this.favoriteCount || 0) - 1);
    }
    this.updateButton(nextState);
    brandDisableTemporarily(this.button);

    try {
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          customer_id: this.customerId,
          metaobject_type: this.objectType,
          target_type: 'metaobject',
          metaobject_id: this.objectId,
          action: action
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update favorite');
      }
    } catch (e) {
      console.error('Error toggling favorite:', e);
      // ロールバック
      this.favoriteCount = previousCount;
      this.updateButton(isCurrentlyFavorited);
      alert('エラーが発生しました。');
    }
  }

  updateButton(isFavorited) {
    if (isFavorited) {
      this.button.classList.add('is-active');
      this.button.classList.add('remove-favorite');
      this.button.classList.remove('add-favorite');
    } else {
      this.button.classList.remove('is-active');
      this.button.classList.add('add-favorite');
      this.button.classList.remove('remove-favorite');
    }

    this.updateFavoriteCountElement();
  }

  syncState(isFavorited, favoriteCount) {
    if (typeof favoriteCount === 'number' && !Number.isNaN(favoriteCount)) {
      this.favoriteCount = Math.max(0, favoriteCount);
    }

    this.updateButton(isFavorited);
  }

  updateFavoriteCountElement() {
    if (this.favoriteCount === undefined || this.favoriteCount === null) return;

    const countEl = document.querySelector(
      `.brand-favorites-count[data-object-type="${this.objectType}"][data-object-id="${this.objectId}"]`
    );
    if (countEl) {
      countEl.textContent = this.favoriteCount;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
   const btnList = document.querySelectorAll('.brand_wishlist_button[data-object-type="brand"]');
   if(btnList) {
     btnList.forEach(btn => {
       new BrandWishlistButton(btn);
     });
   }
});
